/**
 * Estica o número do candidato horizontalmente para ocupar
 * exatamente a mesma largura do nome ("Fábio Sousa").
 */
function fitHeroNumero(): void {
  const heading = document.querySelector<HTMLElement>('.hero-heading')
  if (!heading) return

  const title = heading.querySelector<HTMLElement>('.hero-title')
  const numero = heading.querySelector<HTMLElement>('.hero-numero')
  if (!title || !numero) return

  // Reseta para medir a largura natural
  numero.style.transform = 'scaleX(1)'
  const titleWidth = title.getBoundingClientRect().width
  const numeroWidth = numero.getBoundingClientRect().width
  if (numeroWidth === 0) return

  const scale = titleWidth / numeroWidth
  numero.style.transform = `scaleX(${scale})`
}

function init(): void {
  fitHeroNumero()
  // Recalcula quando as fontes carregam e ao redimensionar
  if (document.fonts?.ready) {
    document.fonts.ready.then(fitHeroNumero)
  }
  let raf = 0
  window.addEventListener('resize', () => {
    cancelAnimationFrame(raf)
    raf = requestAnimationFrame(fitHeroNumero)
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init)
} else {
  init()
}
